var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomBarSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 18.3999C16.0179 18.3999 19.5996 14.8182 19.5996 10.3999C19.5996 5.98162 16.0179 2.3999 11.5996 2.3999C7.18133 2.3999 3.59961 5.98162 3.59961 10.3999C3.59961 14.8182 7.18133 18.3999 11.5996 18.3999Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 20.4L17.25 16.05",
    stroke: "#7A7A7A",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBarSearch);
export default __webpack_public_path__ + "static/media/bottom_bar_search.f30bd8157f5076237d467dce205065bf.svg";
export { ForwardRef as ReactComponent };